import React, { useState } from 'react';
import { useAuth } from "../../context/AuthContext";
import { signUpForEvent } from '../../services/firestore/SGloopService';
import NoUserModal from '../Modal/NoUserModal';
// import your email function here
// import { notifyEventSignup } from "../../services/emailService";

const EventList = ({ eventsData, source }) => {
  const { user, userRef } = useAuth();
  const [noUser, setNoUser] = useState(false);

  const sendEmailNotifications = async (event, userRef) => {
    try {
      // Example: your Cloud Function to send emails
      // await notifyEventSignup({
      //   eventTitle: event.titleOfEvent,
      //   organiserUID: event.uidOfSender.id,
      //   participantUID: userRef.id
      // });

      console.log("Email notification triggered.");
    } catch (err) {
      console.error("Failed to send email:", err);
    }
  };

  return (
    <div className="space-y-6 mx-4">
      {eventsData.map((event) => {
        console.log(event)
        const hasSignedUp = userRef
          ? event.chatBefore?.some((ref) => ref.id === userRef.id)
          : false;

        const isSender = userRef
          ? event.uidOfSender.id === userRef.id
          : false;

        const handleSignUp = async () => {
          if (!userRef) {
            alert("⚠️ Please login to sign up.");
            return;
          }

          // Determine if the event belongs to a sub-group or main group
          let mainGroupId = null;
          let subGroupId = null;
          let sourceType = null;

          if (event?.oneSGSubChat) {
            // Sub-group event
            subGroupId = event.oneSGSubChat.id;
            mainGroupId = event.oneSGSubChat.parent.parent.id;
            sourceType = { subGroupName: true }; // mimics your previous `source?.subGroupName`
          } else if (event?.oneSGMainChat) {
            // Main group event
            mainGroupId = event.oneSGMainChat.id;
            sourceType = { subGroupName: false };
          } else {
            console.warn("⚠️ Event is missing group references");
            return;
          }

          try {
            // Firestore sign-up
            await signUpForEvent(sourceType, event.id, userRef, mainGroupId, subGroupId);

            // Optional: email organiser + participant
           // await sendEmailNotifications(event, userRef);

            console.log("✅ Sign-up successful!");
          } catch (err) {
            console.error("❌ Error during sign-up:", err);
          }
        };

        const handleSignupClick = () => {
          let mainGroupId = null;
          let subGroupId = null;
          let sourceType = null;

          if (event?.oneSGSubChat) {
            // Sub-group event
            subGroupId = event.oneSGSubChat.id;
            mainGroupId = event.oneSGSubChat.parent.parent.id;
            sourceType = { subGroupName: true }; // mimics your previous `source?.subGroupName`
          } else if (event?.oneSGMainChat) {
            // Main group event
            mainGroupId = event.oneSGMainChat.id;
            sourceType = { subGroupName: false };
          } else {
            console.warn("⚠️ Event is missing group references");
            return;
          }

          if (!userRef) {
            setNoUser(true);
            return;
          }
          if (event.formURL && event.formURL !== "") {
            const params = new URLSearchParams({
              eventId: event.id,
              source: source?.subGroupName ? `${subGroupId}-${mainGroupId}` : `${mainGroupId}`
            });

            const finalURL = `${event.formURL}?${params.toString()}`;

            window.open(finalURL, "_blank", "noopener,noreferrer");
            return;
          }

          // Fallback sign up
          handleSignUp(event.id, source, event);
        };


        return (
          <>
          {noUser && <NoUserModal></NoUserModal>}
          <div
            key={event.id}
            className="border rounded-lg shadow-md overflow-hidden flex flex-col md:flex-row"
          >
            {event.imageList?.[0] && (
              <img
                src={event.imageList[0]}
                alt={event.titleOfEvent}
                className="w-full md:w-48 h-48 object-cover"
              />
            )}

            <div className="p-4 flex-1 flex flex-col justify-between">
              <div>
                <h2 className="text-xl font-semibold">{event.titleOfEvent}</h2>
                <p className="text-sm text-gray-500">{event.location}</p>
                <p className="text-sm text-gray-400 mt-1">
                  {event.eventDate?.seconds &&
                    new Date(event.eventDate.seconds * 1000).toLocaleDateString(
                      "en-SG",
                      {
                        weekday: "short",
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      }
                    )}
                </p>
                <p className="text-sm mt-2 whitespace-pre-line">
                  {event.description}
                </p>
              </div>

              <div className="mt-4 flex space-x-2">
                {isSender ? (
                  <button
                    className="px-4 py-1 bg-yellow-400 text-white rounded w-full"
                    onClick={() => alert("Please edit the event through the application")}
                  >
                    Edit
                  </button>
                ) : hasSignedUp ? (
                  <span className="px-4 py-1 bg-green-100 text-green-800 rounded w-full inline-block text-center">
                    Signed Up
                  </span>
                ) : (
                  <button
                    onClick={handleSignupClick}
                    className="px-4 py-1 bg-blue-500 text-white rounded w-full"
                  >
                    Sign Up
                  </button>
                )}
              </div>
            </div>
          </div>
          </>
        );
      })}
    </div>
  );
};

export default EventList;
